import store from "../../../store";
import edit_sbquest from './edit_sbquest';

window.SKD_QUEST_MODAL =  new Vue({
    store,
    name : "SKD_QUEST",
    el: '#sb_quest_block',

    data () {
        return {
            showModal: false,
        }
    },
    created () {

    },
    components : {
        edit_sbquest
    }
});
